// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { noop } from 'lodash/fp';

import { findDeviceTypeMessage } from '~/core/translations/devices';
import { deviceOnlineMessages } from '~/core/translations/devices/intl';
import { deviceTypeToIcon } from '~/core/utils/svg-icons';
import { getDOMOnlyProps } from '~/core/utils/form/form-helpers';

import messages from './intl';
import {
    DeviceIconWrapper,
    InputStyled,
    ItemContainer,
    StatusContainer,
    Status,
    StyledSVGIcon,
    Wrapper,
    IdentifyButton
} from './styles';
import { capabilities as productCapabilities } from '~/core/constants/devices';
import ConditionalFeature from '~/core/components/conditional-feature';
import type { DeviceModel, DeviceType, Region } from '~/core/types/devices';

type Props = {
    field: {
        error: boolean,
        name: string,
        touched: boolean
    },
    localeSuffix?: Region,
    manufacturer?: string,
    model?: DeviceModel,
    online?: boolean,
    type: DeviceType,
    id: string,
    capabilities?: Array<string>,
    identifyDevice: noop,
    isNano1: boolean
};

function DeviceListItem({
    field,
    localeSuffix,
    manufacturer,
    model,
    online,
    type,
    id,
    capabilities,
    identifyDevice,
    isNano1
}: Props) {
    const isIdentifyDeviceEnabled =
        !isNano1 && online && capabilities && capabilities.includes(productCapabilities.IDENTIFY_DEVICE);

    return (
        <Wrapper>
            <DeviceIconWrapper>
                <StyledSVGIcon type={deviceTypeToIcon({ model, type, localeSuffix })} />
            </DeviceIconWrapper>
            <ItemContainer>
                <FormattedMessage {...messages.name}>
                    {m => (
                        <InputStyled
                            {...getDOMOnlyProps(field)}
                            error={(field.touched && field.error) || null}
                            id={field.name}
                            label={m}
                            maxLength={20}
                            touched={field.touched}
                        />
                    )}
                </FormattedMessage>
                <StatusContainer>
                    <Status>
                        <FormattedMessage
                            {...findDeviceTypeMessage(type, manufacturer, model)}
                            values={{ amount: 1 }}
                        />
                        {': '}
                        <FormattedMessage {...deviceOnlineMessages[online ? 'connected' : 'offline']} />
                    </Status>
                    {isIdentifyDeviceEnabled && (
                        <ConditionalFeature condition={featureFlags => featureFlags.identifyProductButton}>
                            {() => (
                                <IdentifyButton onClick={() => identifyDevice(id, type)} type="button">
                                    <FormattedMessage {...deviceOnlineMessages.identify} />
                                </IdentifyButton>
                            )}
                        </ConditionalFeature>
                    )}
                </StatusContainer>
            </ItemContainer>
        </Wrapper>
    );
}

export default DeviceListItem;



// WEBPACK FOOTER //
// ./src/components/widgets/device-list/item/index.js